import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import Chip from "@mui/material/Chip";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import When from "ui/support/When";

const Reason = ({ value }: GridRenderCellParams) => (
    <When
        if={Boolean(value)}
        then={() => (
            <Chip
                size='small'
                color='warning'
                label={value.split(';').at(-1)}
                icon={(
                    <ReportProblemIcon />
                )}
            />
        )}
        else='-'
    />
);

export default Reason;
